/**
 * Sentinel select-value used to denote that
 * a classified should be picked up at the user's school.
 * */
export var MY_SCHOOL_VALUE = 'my_school';
/** Tilstander en annonse kan ha, med menneskevennlige navn. */
export var conditionOptions = [
    { value: 'not_used', label: 'Ikke brukt' },
    { value: 'as_new', label: 'Som ny' },
    { value: 'some_markings', label: 'Noen markeringer' },
    { value: 'worn_but_readable', label: 'Brukt men lesbar' },
];
/** Statuser en bruker selv kan sette på sin annonse (utløpt kan ikke settes manuelt). */
export var selectableStatusOptions = [
    { value: 'active', label: 'Aktiv' },
    { value: 'sold', label: 'Solgt' },
    { value: 'inactive', label: 'Inaktiv' },
];
/** Norsk navn for alle annonsestatuser, inkludert de som kun settes automatisk. */
export var statusLabels = {
    active: 'Aktiv',
    sold: 'Solgt',
    inactive: 'Inaktiv',
    outdated: 'Utløpt',
    deleted: 'Slettet',
};
/**
 * Checks if the given sale point actually is the
 * user's school, as the API returns schools and sale
 * points in the same list.
 * */
export var isSchoolSalePoint = function (salePoint) {
    var asSchool = salePoint;
    return !!asSchool.department || !!asSchool.shortName || !!asSchool.shortname;
};
export var salePointOptionValue = function (salePoint) { return (isSchoolSalePoint(salePoint) ? MY_SCHOOL_VALUE : String(salePoint.id)); };
export var salePointOptionLabel = function (salePoint) {
    if (!isSchoolSalePoint(salePoint)) {
        return salePoint.salePoint;
    }
    var school = salePoint;
    var shortName = school.shortName || school.shortname || school.name;
    var department = school.department ? " " + school.department : '';
    return "" + shortName + department;
};
/** Finds the initial select-value for the sale point of a classified. */
export var findInitialSalePointValue = function (classified) {
    var _a;
    if (classified.pickupAt === 'school') {
        return MY_SCHOOL_VALUE;
    }
    var salePointId = (_a = classified.salePoint) === null || _a === void 0 ? void 0 : _a.id;
    return salePointId ? String(salePointId) : '';
};
/** Builds the initial form values for editing an existing classified. */
export var buildInitialEditValues = function (classified) { return ({
    price: classified.price,
    condition: classified.condition,
    status: classified.status === 'outdated' ? 'inactive' : classified.status,
    salePoint: findInitialSalePointValue(classified),
}); };
/** Maps edit-form values to a classified update request for the API. */
export var buildUpdateRequest = function (values) { return ({
    price: Number(values.price),
    condition: values.condition,
    status: values.status,
    salePoint: values.salePoint,
}); };
